import { orderTypes } from "../types";
import { orderApi } from "../api/orderApi";
import checkIfAsyncReqSuccess from "./checkIfAsyncReqSuccess";
import { getUserDetails } from "./userActions";
import { DATETIMEFORMAT, ITEMSTATUS } from "../../contants";
import {
  checkIfQuantityExceeds,
  findActiveOrderIndex,
  isThatItemInMyOrder,
} from "../reducers/newOrderReducer";
import { isMealBillAndroid, androidPrinter } from "../../native/mealbill-android.mjs";
import price from "../../helpers/calculatePrice";
import moment from "moment";
import dummyActive from "../../helpers/dummyActiveOrder";

export const calculateKOT = ({
  active,
  lastOrderNumber,
  activeOrders,
  tableType,
}) => {
  let kotItems = [];
  active.orderItems.forEach((data) => {
    let lastkotquantity = 0;
    active.KOTS.forEach((d) => {
      d.orderItems.forEach((i) => {
        if (i.itemId === data.itemId) {
          lastkotquantity = lastkotquantity + i.quantity;
        }
      });
    });
  });

  let ItemsQuantity = 0;
  kotItems.map((item, index) => {
    ItemsQuantity = ItemsQuantity + item.quantity;
  });
  const kotData = {
    branchOrderNumber: `# ${lastOrderNumber + activeOrders.length + 1}`,
    orderType: active.orderType,
    orderItems: kotItems,
    orderDate: moment().format(DATETIMEFORMAT),
    tableNumber: active?.tableNumber,

    totalQuantity: ItemsQuantity,
  };
  return {
    kotItems,
    kotData,
  };
};

export const getMyState = (getState, myState) => {
  return getState()[myState];
};

export const setOrderType = (type) => {
  return {
    type: orderTypes.SET_ORDER_TYPE,
    payload: type,
  };
};

export const activateOrder = (data, userName) => {
  return (dispatch, getState) => {
    const branchCode = getMyState(getState, "user").branchCode;
    const activeOrders = getMyState(getState, "order").activeOrders || [];
    const lastOrderNumber = getMyState(getState, "order").lastOrderNumber || 0;

    let maxActiveOrderNumber = 0;
    activeOrders.forEach((order) => {
      const num = parseInt(order.orderNumber) || 0;
      if (num > maxActiveOrderNumber) {
        maxActiveOrderNumber = num;
      }
    });

    const orderNumber = Math.max(lastOrderNumber, maxActiveOrderNumber) + 1;
    const branchOrderNumber = branchCode + orderNumber;
    dispatch(incrementOrderNumberCount());
    return dispatch({
      type: orderTypes.ACTIVATE_ORDER,
      payload: dummyActive(data, userName, orderNumber, branchOrderNumber),

      isSocket: true,
    });
  };
};

export const getSocketOrders = (data) => {
  return {
    type: orderTypes.GET_SOCKET_ORDERS,
    payload: data,
  };
};

export const setTableOrderInfo = (data) => {
  return {
    type: "SET_TABLE_ORDER_INFO",
    payload: data,
  };
};

export const getKotNumber = (data) => {
  return {
    type: "GET_KOT_NUMBER",
    payload: data,
  };
};

export const activateOrderSocket = (data) => {
  return {
    type: orderTypes.ACTIVATE_ORDER_SOCKET,
    payload: data,

    isSocket: false,
  };
};

export const pushItemToActiveOrder = ({ item, isVariant, tableType }) => {
  return (dispatch, getState) => {
    const refId = getMyState(getState, "order").activeOrder;
    const allOrders = getMyState(getState, "order").activeOrders;

    const myItemId = item?.variantId || item?.id || item?.id;
    const activeOrder = allOrders[findActiveOrderIndex(allOrders, refId)];

    if (!activeOrder) {
      alert("No Active Order");
      return;
    }

    if (
      item.isQuantityChecked &&
      item?.lowerLimitQuantity &&
      item.currentStock <= item.lowerLimitQuantity
    ) {
      alert(`Quantity of ${item.itemName} is less.`);
    }

    if (activeOrder.isBillPrinted || activeOrder.isOrderConfirmed) {
      alert(
        "Bill modification not possible after printing. If you wish to change, do it after settlement",
      );
      return;
    }

    const currItem = isThatItemInMyOrder(activeOrder, myItemId);

    if (
      currItem &&
      activeOrder.KOTS[activeOrder.KOTS.length - 1].statusId === 0 &&
      !isVariant
    ) {
      if (checkIfQuantityExceeds(currItem, currItem.quantity + 1)) {
        return dispatch({
          type: "asdasd",
        });
      }

      return dispatch(
        changeItemQuantity({
          quantity: 1,
          itemId: myItemId,
          tableType: tableType,
          index: activeOrder.KOTS.length - 1,
          item,
        }),
      );
    } else {
      if (checkIfQuantityExceeds(item, 1)) {
        return dispatch({
          type: "asdasd",
        });
      }
      return dispatch({
        type: orderTypes.PUSH_ITEM_TO_ORDER,
        isSocket: true,
        payload: {
          refId: refId,
          item: {
            ...item,
            itemId: item?.variantId || item?._id || item?.id,
            isVariant: isVariant,
            quantity: 1,

            itemTotal: 1 * price(tableType[0]?.tableType, item),
            itemStatus: ITEMSTATUS[0].key,
            itemStatusId: ITEMSTATUS[0].value,
            kotQuantity: 0,
            kotTotal: 0,
          },
        },
      });
    }
  };
};

export const pushToppingToItem = ({ toppings, isVariant, resId, branchId }) => {
  return (dispatch, getState) => {
    const refId = getMyState(getState, "order").activeOrder;
    const allOrders = getMyState(getState, "order").activeOrders;

    const activeOrder = allOrders[findActiveOrderIndex(allOrders, refId)];

    if (!activeOrder) {
      alert("No Active Order");
      return;
    }

    if (activeOrder.isBillPrinted) {
      alert(
        "Bill modification not possible after printing. If you wish to change, do it after settlement",
      );
      return;
    }

    const myItem = activeOrder.orderItems[activeOrder.orderItems.length - 1];

    return dispatch({
      type: orderTypes.PUSH_TOPPING_TO_ITEM,
      isSocket: true,
      payload: {
        refId: refId,
        isVariant: isVariant,
        itemId: myItem.itemId,
        itemName: myItem.itemName,
        activeTopping: toppings,
      },
    });
  };
};

export const pushItemToActiveOrderSocket = (item) => {
  return {
    type: orderTypes.PUSH_ITEM_TO_ORDER_SOCKET,
    payload: item,

    isSocket: false,
  };
};

export const changeItemQuantity = ({
  quantity,
  itemId,
  tableType,
  index,
  item,
}) => {
  return (dispatch, getState) => {
    const refId = getMyState(getState, "order").activeOrder;
    return dispatch({
      type: orderTypes.CHANGE_ITEM_QUANTITY,
      isSocket: true,
      payload: {
        refId,
        index,
        quantity,
        itemId,
        tableType,
        item,
      },
    });
  };
};

export const changeItemQuantitySocket = ({ quantity, itemId, tableType }) => {
  return (dispatch, getState) => {
    const refId = getMyState(getState, "order").activeOrder;
    return dispatch({
      type: orderTypes.CHANGE_ITEM_QUANTITY,
      payload: {
        refId,

        quantity,
        itemId,
        tableType,
      },
    });
  };
};

export const setItemAsPrepared = ({ refId, itemId, kotId }) => {
  return {
    isSocket: true,
    type: orderTypes.SET_ITEM_AS_PREPARED,
    payload: {
      refId,
      itemId,
      kotId,
    },
  };
};

export const getTableOrderInfo = (data) => {
  return {
    isSocket: true,
    type: "GET_TABLE_ORDER_INFO",
    payload: {
      tableNumber: data.tableNumber,
    },
  };
};

export const setItemAsPreparedSocket = (orders) => {
  return {
    type: orderTypes.SET_ITEM_AS_PREPARED_SOCKET,
    payload: orders,
  };
};
export const removeItem = (itemId, index) => {
  return (dispatch, getState) => {
    const refId = getMyState(getState, "order").activeOrder;
    return dispatch({
      type: orderTypes.REMOVE_ITEM,
      isSocket: true,
      payload: {
        refId,
        index,
        itemId,
      },
    });
  };
};

export const removeItemSocket = (data) => {
  return (dispatch, getState) => {
    return dispatch({
      type: orderTypes.REMOVE_ITEM,
      payload: data,
    });
  };
};

export const setOtherCharges = (data) => {
  return {
    type: orderTypes.SET_OTHER_CHARGES,
    payload: data,
  };
};

export const setDiscount = (data) => {
  return {
    type: orderTypes.SET_DISCOUNT,
    payload: data,
  };
};
//notdone

export const setOrderToEdit = (order) => {
  return {
    type: orderTypes.SET_ORDER_TO_EDIT,
    payload: order,
  };
};

export const setActiveOrder = (refId) => {
  return {
    type: orderTypes.SET_ACTIVE_ORDER,
    payload: refId,
  };
};

export const deleteLocalOrder = (refId, isSettled = false) => {
  return (dispatch, getState) => {
    const branchCode = getMyState(getState, "user").branchCode;
    return dispatch({
      type: orderTypes.DELETE_LOCAL_ORDER,
      isSocket: true,
      payload: {
        refId,
        branchCode,
        isSettled,
      },
    });
  };
};
export const deleteLocalOrderSocket = (refId) => {
  return {
    type: orderTypes.DELETE_LOCAL_ORDER,
    payload: {
      refId,
    },
  };
};

export const prePrintOrder = (data) => {
  return {
    type: orderTypes.PRE_PRINT_ORDER,
    payload: data,
  };
};

export const setKOTinSocket = (refId, order, print, printOnMobile = false) => {
  return (dispatch) => {
    return dispatch({
      type: orderTypes.SET_KOT_ITEMS,
      isSocket: true,
      payload: {
        refId,
        order,
        // If mobile will print directly, tell the server not to route to Manager.
        print: printOnMobile ? false : print,
        printOnMobile,
      },
    });
  };
};

export const updateOrderDiscountSocket = (refId, data) => (dispatch) => {
  // Optionally, update Redux state if needed
  return dispatch({
    type: "SET_DISCOUNT",
    isSocket: true,
    payload: { refId, ...data },
  });
};

export const setKOTitemsData = ({ customerData }, print) => {
  return async (dispatch, getState) => {
    const orderData = getMyState(getState, "order");
    const refId = orderData.activeOrder;
    const activeOrders = orderData.activeOrders;
    const myOrderIndex = findActiveOrderIndex(activeOrders, refId);
    const active = activeOrders[myOrderIndex];
    const activeClone = {
      ...active,
      customerName: customerData?.customerName,
      customerMobile: customerData?.customerMobile,
      remarks: customerData?.remarks,
    };

    // On Android, check if this phone has a kitchen printer saved.
    // If yes, print directly here and tell the server not to route to Manager.
    let printOnMobile = false;
    if (isMealBillAndroid() && print) {
      try {
        const route = await androidPrinter.getPrintRoute("kitchen");
        printOnMobile = route.destination === "direct" && !!route.profile;
      } catch (_) {
        // getPrintRoute failure → fall back to Manager print as normal
        printOnMobile = false;
      }
    }

    dispatch(setKOTinSocket(refId, activeClone, print, printOnMobile));
  };
};

export const setKOTitemsDataRedux = (data) => {
  return (dispatch, getState) => {
    return dispatch({
      type: orderTypes.SET_KOT_ITEMS,
      payload: data,
    });
  };
};

export const confirmOrder = (data, cb, errorCb) => {
  return (dispatch, getState) => {
    const restaurantName = getState().user?.restaurantName;
    checkIfAsyncReqSuccess(dispatch, {
      successMessage: "Order Successfull",
      errorMessage: "Failed To Order",
      enableMessage: true,

      cb: (response) => {
        dispatch(getUserDetails());
        if (cb) {
          const returnedData =
            response && response.data && response.data.data
              ? response.data.data
              : data;
          cb(returnedData);
        }
      },
      errorCb: errorCb,
      type: orderTypes.CONFIRM_ORDER,
      payload: {
        request: {
          url: data.isEdited ? orderApi.UPDATE_ORDER : orderApi.CREATE_ORDER,
          method: data.isEdited ? "put" : "post",
          data: {
            ...data,
            restaurantName: data.restaurantName || restaurantName,
          },
          headers: {
            "Content-type": "application/json",
          },
        },
      },
    });
  };
};

export const setOrderConfermation = (order) => {
  return {
    type: "SET_ORDER_CONFIRMATIONS",
    isSocket: true,
    payload: {
      order,
    },
  };
};

export const setOrderConfirmationSocket = (order) => {
  return {
    type: "SET_ORDER_CONFIRMATIONS",
    payload: {
      order,
    },
  };
};

export const printOrder = (data, cb, errorCb) => {
  return (dispatch, getState) => {
    dispatch({
      type: orderTypes.PRINT_ORDER,
      payload: data,
    });
  };
};

export const updateOrder = (
  data,
  cb,
  errorCb,
  successMessage,
  errorMessage,
) => {
  return (dispatch, getState) => {
    const restaurantName = getState().user?.restaurantName;

    checkIfAsyncReqSuccess(dispatch, {
      successMessage: successMessage || "Order Payment Received",
      errorMessage: errorMessage || "Failed To Add Payment",
      enableMessage: false,
      cb: (response) => {
        dispatch(getUserDetails());
        cb && cb(response);
      },
      errorCb: errorCb,
      type: orderTypes.UPDATE_ORDER,
      payload: {
        request: {
          url: orderApi.UPDATE_ORDER,
          method: "PUT",
          data: {
            ...data,
            restaurantName: data.restaurantName || restaurantName,
          },
          headers: {
            "Content-type": "application/json",
          },
        },
      },
    });
  };
};

export const editOrder = (data, cb, errorCb, successMessage, errorMessage) => {
  return (dispatch, getState) => {
    const restaurantName = getState().user?.restaurantName;
    return checkIfAsyncReqSuccess(dispatch, {
      successMessage: successMessage || "Order Edited Successfully",
      errorMessage: errorMessage || "Failed To edit Order",
      enableMessage: false,
      cb: cb,
      errorCb: errorCb,
      type: orderTypes.UPDATE_ORDER,
      payload: {
        request: {
          url: orderApi.EDIT_ORDER,
          method: "PUT",
          data: {
            ...data,
            restaurantName: data.restaurantName || restaurantName,
          },
          headers: {
            "Content-type": "application/json",
          },
        },
      },
    });
  };
};

export const MergeTableOrder = (data, refId) => {
  return {
    type: orderTypes.MERGE_ORDER,
    payload: {
      refId: refId,
      data: data,
    },
    isSocket: true,
  };
};

export const getPreviosOrders = (data) => {
  return {
    type: orderTypes.GET_PREVIOS_ORDERS,
    payload: {
      request: {
        url: orderApi.GET_PREVIOS_ORDERS,
        method: "GET",
        params: {
          ...data,
        },
      },
    },
  };
};

export const incrementOrderNumberCount = () => {
  return {
    type: orderTypes.INCREMENT_ORDER_NUMBER_COUNT,
  };
};

export const syncOrders = (data) => {
  return {
    successMessage: "Order Synced Successfully",
    errorMessage: "Failed To Sync Orders",
    type: orderTypes.SYNC_ORDERS,
    payload: {
      request: {
        url: orderApi.SYNC_ORDERS,
        method: "POST",
        data: data,
        headers: {
          "Content-type": "application/json",
        },
      },
    },
  };
};

export const removeItemCreateKot = (data) => {
  return {
    successMessage: "Removed Item Successfully",
    errorMessage: "Failed To remove item",
    type: orderTypes.REMOVE_ITEM_CREATE_KOT,
    payload: {
      request: {
        url: orderApi.REMOVE_ITEM_CREATE_KOT,
        method: "POST",
        data: data,
        headers: {
          "Content-type": "application/json",
        },
      },
    },
  };
};
